import { render } from "./ProfileCommonInfo.vue?vue&type=template&id=55301fd6&scoped=true"
const script = {}

import "./ProfileCommonInfo.vue?vue&type=style&index=0&id=55301fd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55301fd6"]])

export default __exports__